module.exports = __webpack_public_path__ + "img/logout-1.cec6ffe4.svg";